import React from 'react';
import { Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';

// Emails allowed to manage the blog. This app has no separate "admin" role
// in the database (see ProtectedRoute.jsx — it only distinguishes student
// vs teacher), and this platform can have MULTIPLE independent teacher
// accounts, so a plain teacher-only check isn't enough here: publishing to
// the public blog needs to stay limited to a specific owner account, not
// every teacher who signs up.
const ADMIN_EMAILS = (process.env.REACT_APP_BLOG_ADMIN_EMAILS || '')
  .split(',')
  .map((e) => e.trim().toLowerCase())
  .filter(Boolean);

export function isBlogAdmin() {
  try {
    const raw = localStorage.getItem('currentUser');
    if (!raw) return false;
    const user = JSON.parse(raw);
    const email = (user?.email || '').toLowerCase();
    return !!email && ADMIN_EMAILS.includes(email);
  } catch (_) {
    return false;
  }
}

export default function AdminRoute({ children }) {
  return (
    <ProtectedRoute>
      {isBlogAdmin() ? children : <Navigate to="/" replace />}
    </ProtectedRoute>
  );
}
